import * as firebase from 'firebase/app';
import Event from '../models/Event.js';
require('firebase/firestore');
require('firebase/storage');

const state = {
  allEvents: [],
  specificEvent: new Event()
};

const getters = {
  getEvents: state => state.allEvents,
  getEvent: state => state.specificEvent
};

const actions = {
  getAllEvents({
    commit
  }) {
    firebase.firestore().collection("events").onSnapshot(snapshot => {
      commit("setLoading", true);

      let events = [];
      snapshot.forEach(doc => {
        let e = new Event(doc.id, convertDateTime(doc.data().startDate), convertDateTime(doc.data().endDate), doc.data().title, doc.data().description, doc.data().created);
        events.push(e);
      });
      commit("setEvents", events);
      commit("setLoading", false);
    }, error => {
      commit("setLoading", false);
      console.error(error);
    });
  },
  getSpecificEvent({
    commit
  }, id) {
    firebase.firestore().collection("events").doc(id).get().then(doc => {
      commit("setLoading", false);

      let e = new Event(doc.id, doc.data().startDate, doc.data().endDate, doc.data().title, doc.data().description, null, doc.data().imageUrl, doc.data().fullPath, doc.data().created);

      commit("setSpecificEvent", e);
      commit("setLoading", false);
    }, error => {
      commit("setLoading", false);
      console.error(error);
    });
  },
  createEvent({
    commit
  }, e) {
    let id = 0;

    firebase.firestore().collection("events").add({
        startDate: e.startDate,
        endDate: e.endDate,
        title: e.title,
        description: e.description,
        created: e.created
      })
      .then(docRef => {
        id = docRef.id;
        console.log("Event created with ID: ", docRef.id);
        const fileName = e.image.name;
        const ext = fileName.slice(fileName.lastIndexOf("."));
        return firebase.storage().ref("events/" + id + ext).put(e.image);
      })
      .then(fileData => {
        console.log("Uploaded image.");
        let url = fileData.metadata.downloadURLs[0];
        return firebase.firestore().collection("events").doc(id).update({
          imageUrl: url,
          fullPath: fileData.metadata.fullPath
        });
      })
      .catch(error => {
        console.error("Error creating event: ", error);
      });
  },
  editEvent({
    commit
  }, e) {
    firebase.firestore().collection("events").doc(e.id).update({
      title: e.title,
      description: e.description,
      startDate: e.startDate,
      endDate: e.endDate
    }).then(docRef => {
      if (e.fullPath != undefined) {
        let imageRef = firebase.storage().ref().child(docRef.data().fullPath);
        return imageRef.delete();
      }
    }).then(result => {
      console.log("Event " + e.id + " has been updated.");
      const fileName = e.image.name;
      const ext = fileName.slice(fileName.lastIndexOf("."));
      return firebase.storage().ref("events/" + e.id + ext).put(e.image);
    }).then(fileData => {
      console.log("updated photo");
      let url = fileData.metadata.downloadURLs[0];
      return firebase.firestore().collection("events").doc(e.id).update({
        imageUrl: url,
        fullPath: fileData.metadata.fullPath
      });
    }).catch(error => {
      console.error(error);
    });
  },
  deleteEvent({
    commit
  }, id) {
    firebase.firestore().collection("events").doc(id).get()
      .then(docRef => {
        let imageRef = firebase.storage().ref().child(docRef.data().fullPath);

        return imageRef.delete();
      }).then(result => {
        console.log("Deleted Image");
        return firebase.firestore().collection("events").doc(id).delete();
      }).then(result => {
        console.log("Deleted event");
      }).catch(error => {
        console.error(error);
      });
  }
};

const mutations = {
  setEvents(state, events) {
    state.allEvents = events;
  },
  setSpecificEvent(state, e) {
    state.specificEvent = e;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};

function convertDateTime(ISOstring) {
  let date = new Date(ISOstring);

  return '' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
}